import React from 'react';
import {Trans} from 'react-i18next';
import {Field} from 'formik';
import ToggleEnableField from '../../../components/togglernablefield';
import Section from '../../layout/Section';

export default function RecommendationTabSettings({displayRecommendLayout}) {
  return (
    <Section
      title={
        <Trans i18nKey="p.s.uiconfiguration.skinresultpage.recommendation.tabsettings">
          Recommendation Tab Settings
        </Trans>
      }
    >
      <div>
        <Trans i18nKey="p.s.uiconfiguration.skinresultpage.recommendation.setting.desc">
          Select which tabs are enabled and their display order on
          Recommendation page.
        </Trans>
      </div>
      <Field name="skinResultPage.recommendation.tabs">
        {props => (
          <div className="form-group  flex__block flex__item-align-center flex__flow-wrap">
            <div className="col-md-12">
              <ToggleEnableField
                itemList={displayRecommendLayout}
                onChange={list => {
                  const seqList = [...list];
                  props.form.setFieldValue(props.field.name, seqList);
                }}
                minEnable={1}
                type={'SKIN_ANALYSIS'}
              />
            </div>
          </div>
        )}
      </Field>
    </Section>
  );
}
